import script from "./AppRuleVersionPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./AppRuleVersionPicker.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__